/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FloorplanDto } from '../../models/floorplan-dto';

export interface FloorplanControllerFindById$Params {
  id: string;
  clientWorkspaceId: string;
}

export function floorplanControllerFindById(http: HttpClient, rootUrl: string, params: FloorplanControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<FloorplanDto>> {
  const rb = new RequestBuilder(rootUrl, floorplanControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FloorplanDto>;
    })
  );
}

floorplanControllerFindById.PATH = '/api/floorplan/{clientWorkspaceId}/{id}';
